module.exports = __webpack_public_path__ + "img/whatsapp.933bfa69.png";